// App.js
import './App.css'
import { MyKeysView } from './components/MyKeysView/MyKeysView'
import { Header } from './components/Header/Header'
import { Routes, Navigate , Route,  useLocation } from 'react-router-dom'
import { AppRoutes } from './AppRoutes'


const Router = ({fileInfo, error, loading}) => {
  const { pathname } = useLocation()
  return (
    <Routes>
      {/* Remove trailing slash */}
      <Route path="/:url*(/+)" element={<Navigate to={pathname.slice(0, -1)} />} />
      <Route path={AppRoutes.Keys} element={<MyKeysView />} />
    </Routes>
  )
}

function App() {

  return (
    <div className="App">
      <Header />
      <Router />
    </div>
  )
}

export default App
